import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const StepCard = ({ className, children, ...rest }) => (_jsx("div", { className: classNames("cvr-stepcard", className), ...rest, children: children }));
